<template>
    <div class="main-content">
        <slot/>
    </div>
</template>